/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Task_Update_ErrorInputs */

const en_task_update_error = /** @type {(inputs: Task_Update_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update task: ${i?.message}`)
};

const pt_br2_task_update_error = /** @type {(inputs: Task_Update_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar atividade: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to update task: {message}" |
*
* @param {Task_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_update_error = /** @type {((inputs: Task_Update_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Update_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_update_error(inputs)
	return pt_br2_task_update_error(inputs)
});